/** Who an event is for, besides a kid by name. Shared by the add and edit sheets. */
export const FAMILY_CHIP = "__family__";
export const WORK_CHIP = "__work__";
